var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('data-table',{attrs:{"title":"Sites By Landord","table-ref":"landlordstable2","url":'report/property/renewals/' + this.rowData.id,"show-search":false,"sort-field":"siteName","search-placeholder":"Search Site Name...","fields":_vm.fields,"track-by":"id","detail-component":"property-details"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }